// Canonical account-chip subtitle so EVERY ZAFROI app renders the same identity
// line in the top-bar UserMenu: "<tier> · <real role names>". This is the single
// source of truth — apps must compute the UserMenu `subtitle` from here rather
// than rolling their own, otherwise the header reads differently per app
// (enum role vs real roles vs an app-specific role model).
//
// Falls back to the legacy enum role label only when the real `roles` array is
// absent (older sessions before /auth/me carried `roles`).

const TIER_LABEL: Record<string, string> = {
  PLATFORM_ADMIN: 'Platform',
  TENANT_ADMIN: 'Admin',
  PORTAL: 'Portal',
  INTEGRATION: 'Integration',
};

const ENUM_ROLE_LABEL: Record<string, string> = {
  admin: 'Admin',
  manager: 'Manager',
  operator: 'Operator',
  viewer: 'Viewer',
};

export interface AccountSubtitleInput {
  /** API tier (PLATFORM_ADMIN | TENANT_ADMIN | PORTAL | INTEGRATION). */
  tier?: string | null;
  /** Legacy enum role — used only as a fallback when `roles` is absent. */
  role?: string | null;
  /** The user's real tenant-wide role names from /auth/me (Owner/Admin/Business Head/…). */
  roles?: string[] | null;
}

export function accountSubtitle(input: AccountSubtitleInput): string {
  const tierLabel = input.tier ? (TIER_LABEL[input.tier] ?? input.tier) : '';
  const roleLabel =
    input.roles && input.roles.length
      ? input.roles.join(', ')
      : input.role
        ? (ENUM_ROLE_LABEL[input.role] ?? input.role)
        : '';
  if (tierLabel && roleLabel) return `${tierLabel} · ${roleLabel}`;
  return roleLabel || tierLabel;
}
